(function () {
	function bindPlayButtons(root) {
		var inners = root.querySelectorAll('.media-text-steps__media-inner');
		inners.forEach(function (inner) {
			var video = inner.querySelector('video.media-text-steps__video');
			var btn = inner.querySelector('button[data-media-step-play]');
			if (!video || !btn || btn.dataset.mediaStepBound === '1') return;
			btn.dataset.mediaStepBound = '1';

			function syncPlayButton() {
				var playing = !video.paused;
				btn.classList.toggle('is-playing', playing);
				btn.setAttribute('aria-pressed', playing ? 'true' : 'false');
			}

			btn.addEventListener('click', function (e) {
				e.preventDefault();
				if (video.paused) {
					video.play().catch(function () {});
				} else {
					video.pause();
				}
			});

			video.addEventListener('play', syncPlayButton);
			video.addEventListener('pause', syncPlayButton);
			video.addEventListener('ended', syncPlayButton);
			syncPlayButton();
		});
	}
	function init(root) {
		var el = root && root.querySelector ? root : document;
		bindPlayButtons(el);
	}

	document.addEventListener('DOMContentLoaded', function () {
		init(document);
	});
	document.addEventListener('shopify:section:load', function (ev) {
		if (!ev.target || !ev.target.querySelectorAll) return;
		init(ev.target);
		ev.target.querySelectorAll('.media-text-steps__media-inner[data-video-poster]').forEach(function (inner) {
			var v = inner.querySelector('video.media-text-steps__video');
			var u = inner.getAttribute('data-video-poster');
			if (v && u) v.setAttribute('poster', u);
		});
	});
})();
